import { Injectable } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Clearance } from "../../../interfaces/clearance";

@Injectable({
  providedIn: 'root'
})
export class ClearanceService {
  api: string = `${environment.api}/student/clearance`;

  constructor(private http: HttpClient) {
  }

  public index() {
    return this.http.get<Clearance[]>(this.api, { observe: "body" });
  }

  public submitClearance(uuid: string, payload: { file: File, thumbnail: File }) {
    const formData = new FormData();
    formData.set('file', payload.file);
    formData.set('thumbnail', payload.thumbnail);

    return this.http.post<Clearance>(`${this.api}/${uuid}`, formData, { observe: "response" });
  }

  public update(uuid: string, payload: any) {
    return this.http.put<Clearance>(`${this.api}/${uuid}`, payload, { observe: "body" });
  }

  public destroy(uuid: string) {
    return this.http.delete(`${this.api}/${uuid}`, { observe: "response" });
  }

  public find(uuid: string) {
    return this.http.get(`${this.api}/${uuid}`, { observe: "body" });
  }
}
